<template>
  <AdminLayout>
    <template #breadcrumb>
      <breadcrumb-link view="AdminUserList" label="Users" />
      <breadcrumb-link
        view="UserUpdate"
        :params="{ id: user.id }"
        :label="`Update ${user.first_name} ${user.last_name}`"
        :active="true"
        v-if="!loading"
      />
    </template>
    <UserUpdateForm v-if="!loading" :is-for-admin="true" :user="user"></UserUpdateForm>
  </AdminLayout>
</template>

<script>
import request from '../../request';
import { mapGetters } from 'vuex';
import UserUpdateForm from '../../components/UserUpdateForm';
import AdminLayout from '../../layouts/AdminLayout.vue';

export default {
  name: 'AdminUserUpdate',
  components: {
    UserUpdateForm,
    AdminLayout,
  },
  data() {
    return {
      loading: true,
      user: null,
    };
  },
  computed: {
    ...mapGetters(['organization']),
  },
  beforeRouteEnter(to, from, next) {
    request
      .get(`admin/users/${to.params.id}`)
      .then((resp) => next((vm) => vm.setData(resp.data.user)))
      .catch(() => next({ name: 'NotFound' }));
  },
  methods: {
    setData(user) {
      this.user = user;
      this.loading = false;
    },
  },
};
</script>
